import React from "react";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import LoginPage from "./components/forms/LoginPage";
import ForgotPassword from "./components/forms/ForgotPassword";
import History from "./components/history/History";
import PendingApprovalMain from "./components/pending_approval/PendingApprovalMain";
import PendingApprovalView from "./components/pending_approval/PendingApprovalView";
import Dashboard from "./components/dashboard/Dashboard";
import ManageUsers from "./components/user_management/ManageUsers";
import ManageRoles from "./components/user_management/ManageRoles";
import EmailVerify from "./components/forms/EmailVerify";
import SetPassword from "./components/forms/SetPassword";
import EditProfile from "./components/EditProfile";
import PrivateRoute from './components/PrivateRoute';
import CreateRole from "./components/user_management/CreateRole";
import PieChart from "./components/reports/PieChart";
import MapComponent from "./components/reports/MapComponent";
import ColumnChart from "./components/reports/ColumnChart";

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/forget-password" element={<ForgotPassword />} />
        <Route path="/verify-email" element={<EmailVerify />} />
        <Route path="/reset-password" element={<SetPassword />} />
        <Route path="/dashboard" element={<PrivateRoute element={<Dashboard />} />} />
        <Route path="/history" element={<PrivateRoute element={<History />} />} />
        <Route path="/pending-approval" element={<PrivateRoute element={<PendingApprovalMain />} />} />
        <Route path="/pending-approval/:id" element={<PrivateRoute element={<PendingApprovalView />} />} />
        <Route path="/pie-chart" element={<PrivateRoute element={<PieChart />} />} />
        <Route path="/map-chart" element={<PrivateRoute element={<MapComponent />} />} />
        <Route path="/column-chart" element={<PrivateRoute element={<ColumnChart />} />} />
        <Route path="/manage-users" element={<PrivateRoute element={<ManageUsers />} />} />
        <Route path="/manage-roles" element={<PrivateRoute element={<ManageRoles />} />} />
        <Route path="/create-role" element={<PrivateRoute element={<CreateRole />} />} />
        <Route path="/profile" element={<PrivateRoute element={<EditProfile />} />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
